function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import messages from '../../../messages';
import styles from './Header.pcss';
class Legend extends React.Component {
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.dailyLogReport__legend,
            children: [
                /*#__PURE__*/ _jsx("h1", {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.dailyReport.legend))
                }),
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.dailyLogReport__legendRow,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.dailyLogReport__legendExamples,
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: styles.relatedData__wrapper,
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: styles.relatedData__valueWrapper,
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    children: "#"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: styles.relatedData__secondValueWrapper,
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    children: "##"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.dailyLogReport__legendTitles,
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.dailyReport.legendInjection))
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.dailyLogReport__legendRow,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.dailyLogReport__legendExamples,
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: styles.reading__wrapper,
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: styles.reading__valueMenualWrapper,
                                            children: /*#__PURE__*/ _jsx("div", {
                                                children: "#"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.dailyLogReport__legendTitles,
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.dailyReport.legendManual))
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
export default withStyles(styles)(Legend);
